import {
  IconBolt,
  IconCalendarBolt,
  IconFaceId,
  IconId,
  IconPhoneCheck,
} from "@tabler/icons-react";
import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Group } from "@mantine/core";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const navigate = useNavigate();
  
  // Load initial state from localStorage if available
  const loadInitialState = () => {
    const savedSettings = localStorage.getItem("demoSettings");
    const defaultState = {
      selectedClientApp: localStorage.getItem("selectedClientApp")
        ? localStorage.getItem("selectedClientApp")
        : "/register",
      journey: "modularAV",
      journeyTitle: "ID Document with Express Options",
      journeyType: "linear",
      age: "21+",
      language: "en",
      idmaxCountry: "US",
      isAgeActive: true,
      isAgeCustom: false,
      customAgeType: "",
      customAgeValue: "",
      isCollectCustomerData: false,
      isSidebarShown: true,
      isRouteModalOpened: false,
      cart: [],
      cartTotal: 0,
      advancedSettings: {
        email: "test05@veratad.com",
        route_id: "p8a7b9c2-4d5e-4b7d-8e2a-4f6c9d8b1e2a",
        settings_id: "s9d8f6c7-4b7d-8e2a-f8a7-4c5e9d8b1e2a",
        brand_id: "o7e2a8f6-4b7d-9e2a-7f8a-6c4e5b8d1f2a",
        settings: {
          test_mode: true,
          block: false,
          isCloseButtonShown: true,
          shouldShowContinueOnDesktop: false,
          isReactNative: false,
          isFooterShown: false
        },
        webhook: {
          endpoint: "https://example.com",
          hmac: {
            enabled: false,
            secret: ""
          },
          basicAuth: {
            enabled: false,
            username: "",
            password: ""
          }
        },
        dataFields: {
          fn: false,
          ln: false,
          addr: false,
          city: false,
          state: false,
          zip: false,
          phone: false,
          dob: false,
          ssn: false,
          email: false,
          reference: false,
          custom: false
        },
        additionalData: {
          key_1: "value_1",
          key_2: "value_2"
        },
        styles: {
          colors: {
            "custom-green": [
              "#B3ECE7",
              "#8FE3DB",
              "#6BDACF",
              "#47D1C3",
              "#23C8B7",
              "#11BFA5",
              "#0AA58D",
              "#008B75",
              "#006E5D",
              "#005145"
            ]
          },
          primaryColor: "custom-green",
          primaryShade: 5,
          colorScheme: "light",
          logo_url: "https://example.com/logo.png",
          defaultRadius: "md"
        },
        resultMessages: {
          success: {
            verificationSuccessTitle: "Verification Success",
            verificationSuccessSubTitle: "You have been verified"
          },
          failure: {
            verificationFailureTitle: "Verification Failure",
            verificationFailureSubTitle: "You have not been verified"
          },
          error: {
            verificationErrorTitle: "System Error",
            verificationErrorSubTitle: "Please contact customer service"
          }
        }
      },
      customerData: {
        fn: {
          label: "First Name",
          key: "fn",
          checked: false,
          value: null,
        },
        ln: {
          label: "Last Name",
          key: "ln",
          checked: false,
          value: null,
        },
        addr: {
          label: "Street Address",
          key: "addr",
          checked: false,
          value: null,
        },
        city: {
          label: "City",
          key: "city",
          checked: false,
          value: null,
        },
        state: {
          label: "State",
          key: "state",
          checked: false,
          value: null,
        },
        zip: {
          label: "Zip",
          key: "ln",
          checked: false,
          value: null,
        },
        dob: {
          label: "Date of Birth",
          key: "dob",
          checked: false,
          value: null,
        },
        ssn: {
          label: "SSN",
          key: "ssn",
          checked: false,
          value: null,
        },
        phone: {
          label: "Phone",
          key: "phone",
          checked: false,
          value: null,
        },
        email: {
          label: "Email",
          key: "email",
          checked: false,
          value: null,
        },
      },
      journeys: [
      {
        value: "data_match_to_id_doc",
        types: ["data match", "identity document"],
        title: "Data Match to ID Document",
        description: "Runs a data match and on failure ID Document",
      },
      {
        value: "agematch_address_dob",
        types: ["data match"],
        title: "AgeMatch Address and DOB",
        description: "Runs an AgeMatch check with address and DOB",
      },
      {
        value: "agematch_address_dob_doc",
        types: ["data match", "identity document"],
        title: "AgeMatch Address and DOB to ID Scan",
        description:
          "Runs an AgeMatch check with address and DOB and then ID scan",
      },
      {
        value: "phone_agematch_address_dob_dcams_express",
        types: ["data match", "identity document", "phone", "express"],
        title: "Phone, Age w/Address, DCAMS w/Express",
        description: "Phone to Age with address and then DCAMS with express",
      },
      {
        value: "coppa_only",
        types: ["data match"],
        title: "Data Match COPPA",
        description: "Runs an ID document with selfie only",
      },
      {
        value: "kba_only",
        types: ["data match", "kba"],
        title: "KBA Only",
        description: "Runs a KBA process",
      },
      {
        value: "phone_only",
        types: ["phone"],
        title: "Phone Only",
        description: "Runs a Smart2FA only",
      },
      {
        value: "phone_to_id_doc_with_selfie",
        types: ["phone", "identity document", "face"],
        title: "Phone to ID Document With Selfie",
        description: "Runs a Smart2FA and on failure ID Document",
      },
      {
        value: "phone_to_id_doc_express",
        types: ["phone", "identity document", "express", "idmax"],
        title: "Phone to ID Document Express",
        description: "Runs a Smart2FA and on failure ID Express",
      },
      {
        value: "phone_data_doc",
        types: ["phone", "data match", "identity document"],
        title: "Phone to Data to ID Document",
        description: "Runs a Smart2FA, SSN and then ID Document",
      },
      {
        value: "id_doc",
        types: ["identity document"],
        title: "ID Document Only",
        description: "Runs an ID document only",
      },
      {
        value: "clear_only",
        types: ["identity document", "idmax", "express"],
        title: "IDMax CLEAR Only",
        description: "Runs a CLEAR only",
      },
      {
        value: "plaid_only",
        types: ["identity document", "idmax", "express"],
        title: "IDMax PLAID Only",
        description: "Runs a PLAID only",
      },
      {
        value: "mdl_la_only",
        types: ["identity document", "idmax", "express"],
        title: "IDMax LA Wallet Only",
        description: "Runs a LA Wallet only",
      },
      {
        value: "mdl_ca_only",
        types: ["identity document", "idmax", "express"],
        title: "IDMax California DMV Only",
        description: "Runs a California DMV Only",
      },
      {
        value: "mdl_ca_only_test",
        types: ["identity document", "idmax", "express"],
        title: "IDMax California DMV Only (test)",
        description: "Runs a California DMV Only (test",
      },
      {
        value: "digilocker_only",
        types: ["identity document", "idmax", "express"],
        title: "IDMax Digilocker Only",
        description: "Runs a Digilocker only",
      },
      {
        value: "id_doc_w_express",
        types: ["express", "identity document", "idmax"],
        title: "ID Document with Express Options",
        description: "Runs an ID document with express options",
      },
      {
        value: "id_doc_w_selfie",
        types: ["face", "identity document"],
        title: "ID Document with Selfie Only",
        description: "Runs an ID document with selfie only",
      },
      {
        value: "estimation_to_phone_to_id_doc",
        types: ["face", "phone", "identity document"],
        title: "Estimation to Phone to ID Document",
        description:
          "Runs an estimation and then phone and then ID with Express",
        },
      ],
      customAgeRangeEnd: null,
      method: "popup",
      modularChoices: ["id_doc_express_options"],
      addons: {
        fraudScore: {
          active: true,
          checked: true,
          label: "Fraud Score",
          description: "Returns a score of fraud probability",
        },
        vPin: {
          active: true,
          checked: true,
          label: "VPIN",
          description: "Provides a identification number for customers",
        },
        bouncer: {
          active: true,
          checked: true,
          label: "Bouncer",
          description:
            "ML model that identifies and blocks customers based on rules",
        },
        phoneInsights: {
          active: true,
          checked: true,
          label: "Phone Insights",
          description: "Gathers insights on phone numbers",
        },
        deviceInsights: {
          active: false,
          checked: false,
          label: "Device Insights",
          description: "Collects data on user devices",
        },
        location: {
          active: false,
          checked: false,
          label: "Location",
          description: "GPS location for fraud and compliance",
        },
      },
    };

    if (savedSettings) {
      try {
        const parsedSettings = JSON.parse(savedSettings);
        // Ensure cart arrays are properly initialized
        if (!parsedSettings.cart) parsedSettings.cart = [];
        if (typeof parsedSettings.cartTotal !== 'number') parsedSettings.cartTotal = 0;
        return { ...defaultState, ...parsedSettings };
      } catch (error) {
        console.error("Error parsing saved settings:", error);
        return defaultState;
      }
    }
    return defaultState;
  };

  const [state, setState] = useState(loadInitialState());

  useEffect(() => {
    // Don't auto-navigate if we're on special pages or if we're already on the target page
    const currentPath = window.location.pathname;
    const specialPages = ['/configuration', '/checkout', '/checkout/return'];
    
    console.log('🔍 Navigation Debug:', {
      currentPath,
      selectedClientApp: state.selectedClientApp,
      isSpecialPage: specialPages.includes(currentPath),
      shouldNavigate: !specialPages.includes(currentPath) && currentPath !== state.selectedClientApp
    });
    
    if (!specialPages.includes(currentPath) && currentPath !== state.selectedClientApp) {
      console.log('🚀 Navigating to:', state.selectedClientApp);
      navigate(state.selectedClientApp);
    }
  }, [state.selectedClientApp, navigate]);

  const setContextValue = (key, value) => {
    setState((prevState) => {
      if (prevState[key] === value) return prevState; // no change, don't update state
      const newState = { ...prevState, [key]: value };
      // Save to localStorage whenever context changes (except for UI-only properties)
      const uiOnlyKeys = ['isSidebarShown', 'isRouteModalOpened'];
      if (!uiOnlyKeys.includes(key)) {
        localStorage.setItem("demoSettings", JSON.stringify(newState));
      }
      return newState;
    });
  };

  const updateAddons = (key, updatedAddon) => {
    setState((prevState) => {
      const newState = {
        ...prevState,
        addons: {
          ...prevState.addons,
          [key]: updatedAddon,
        },
      };
      localStorage.setItem("demoSettings", JSON.stringify(newState));
      return newState;
    });
  };

  const updateCustomerFields = (key, updatedFields) => {
    setState((prevState) => {
      const newState = {
        ...prevState,
        customerData: {
          ...prevState.customerData,
          [key]: updatedFields,
        },
      };
      localStorage.setItem("demoSettings", JSON.stringify(newState));
      return newState;
    });
  };

  const addToCart = (item) => {
    setState((prevState) => {
      const existingItem = prevState.cart.find(cartItem => cartItem.name === item.name);
      let newCart;
      
      if (existingItem) {
        newCart = prevState.cart.map(cartItem => 
          cartItem.name === item.name 
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        );
      } else {
        newCart = [...prevState.cart, { ...item, quantity: 1 }];
      }
      
      const newTotal = newCart.reduce((total, cartItem) => total + (parseFloat(cartItem.cost) * cartItem.quantity), 0);
      
      const newState = { 
        ...prevState, 
        cart: newCart,
        cartTotal: newTotal 
      };
      
      localStorage.setItem("demoSettings", JSON.stringify(newState));
      return newState;
    });
  };

  const removeFromCart = (itemName) => {
    setState((prevState) => {
      const newCart = prevState.cart.filter(item => item.name !== itemName);
      const newTotal = newCart.reduce((total, cartItem) => total + (parseFloat(cartItem.cost) * cartItem.quantity), 0);
      
      const newState = { 
        ...prevState, 
        cart: newCart,
        cartTotal: newTotal 
      };
      
      localStorage.setItem("demoSettings", JSON.stringify(newState));
      return newState;
    });
  };

  const clearCart = () => {
    setState((prevState) => {
      const newState = {
        ...prevState,
        cart: [],
        cartTotal: 0
      };

      localStorage.setItem("demoSettings", JSON.stringify(newState));
      return newState;
    });
  };

  const updateCartItemQuantity = (itemName, newQuantity) => {
    setState((prevState) => {
      const newCart = prevState.cart.map(item =>
        item.name === itemName ? { ...item, quantity: newQuantity } : item
      );
      const newTotal = newCart.reduce((total, cartItem) => total + (parseFloat(cartItem.cost) * cartItem.quantity), 0);

      const newState = {
        ...prevState,
        cart: newCart,
        cartTotal: newTotal
      };

      localStorage.setItem("demoSettings", JSON.stringify(newState));
      return newState;
    });
  };

  const updateAdvancedSettings = (path, value) => {
    setState((prevState) => {
      const keys = path.split('.');
      const newAdvancedSettings = { ...prevState.advancedSettings };
      
      let current = newAdvancedSettings;
      for (let i = 0; i < keys.length - 1; i++) {
        current[keys[i]] = { ...current[keys[i]] };
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = value;
      
      const newState = { 
        ...prevState, 
        advancedSettings: newAdvancedSettings
      };
      
      localStorage.setItem("demoSettings", JSON.stringify(newState));
      return newState;
    });
  };

  // Wine store checkout settings
  const [wineStoreSettings, setWineStoreSettings] = useState(() => {
    const saved = localStorage.getItem("wineStoreSettings");
    if (saved) {
      try { return JSON.parse(saved); } catch (e) { /* ignore */ }
    }
    return {
      optionalFields: {
        firstName: true,
        lastName: true,
        phone: false,
        dob: false,
        ssn4: false,
        address: true,
      },
      integrationMethod: "iframe",
      testMode: true,
      age: 21,
      wineAge: 21,
    };
  });

  const updateWineStoreSettings = (updates) => {
    setWineStoreSettings((prev) => {
      const next = { ...prev, ...updates };
      localStorage.setItem("wineStoreSettings", JSON.stringify(next));
      return next;
    });
  };

  // Social media flow state
  const [socialMediaFlow, setSocialMediaFlow] = useState({
    step: "landing",
    username: "",
    email: "",
  });

  const updateSocialMediaFlow = (updates) => {
    setSocialMediaFlow((prev) => ({ ...prev, ...updates }));
  };

  // Fintech flow state
  const [fintechFlow, setFintechFlow] = useState({
    step: "landing",
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    ssn4: "",
  });

  const updateFintechFlow = (updates) => {
    setFintechFlow((prev) => ({ ...prev, ...updates }));
  };

  const contextValue = {
    globalState: state,
    setContextValue,
    updateAddons,
    updateCustomerFields,
    addToCart,
    removeFromCart,
    clearCart,
    updateCartItemQuantity,
    updateAdvancedSettings,
    wineStoreSettings,
    updateWineStoreSettings,
    socialMediaFlow,
    updateSocialMediaFlow,
    fintechFlow,
    updateFintechFlow,
  };

  return (
    <GlobalContext.Provider value={contextValue}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);
